
export default function limitTo(string, cap) {
  // Default limit to 100 characters.
  cap = !cap ? 100 : cap;
  return string.slice(0,cap);
}
